module.exports = __webpack_public_path__ + "static/media/measureArea.80c0623f.svg";